import { baseSiteEndPoint, buildHeaders, getSellerID, urlFilters } from "./common";
import { authorizedFetch } from "./login";

export const apiInvitationLinkList = async (filters) => {
  try {
    const response = await authorizedFetch(
      urlFilters(`${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/invitation-links`, filters),
      {
        method: "GET",
        headers: buildHeaders(),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiInvitationLinkDetails = async (id) => {
  try {
    const response = await authorizedFetch(
      `${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/invitation-links/${id}`,
      {
        method: "GET",
        headers: buildHeaders(),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiCreateInvitationLink = async (jsonData) => {
  try {
    const response = await authorizedFetch(
      `${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/invitation-links/`,
      {
        method: "POST",
        headers: buildHeaders(),
        body: JSON.stringify(jsonData),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiEditInvitationLink = async (id, jsonData) => {
  try {
    const response = await authorizedFetch(
      `${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/invitation-links/${id}/`,
      {
        method: "PUT",
        headers: buildHeaders(),
        body: JSON.stringify(jsonData),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiDeleteInvitationLink = async (id) => {
  try {
    const response = await authorizedFetch(
      `${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/invitation-links/${id}`,
      {
        method: "DELETE",
        headers: buildHeaders(),
      }
    );
    if (response.status === 204) {
      return { success: true, message: "Link de convite excluído com sucesso!" };
    } else {
      const data = await response.json();
      throw new Error(data.message || "Erro ao excluir o link de convite");
    }
  } catch (error) {
    throw error;
  }
};
